import { Avatar, Button, Space } from "antd";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { StyledButton } from "../../../Common/Components";
import PermissionCheck from "../../../Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { getRoleTranslationKey } from "~utilities/getRoleTranslationKey";
import { getEditPersonLink } from "../../SeasonOfficials/utils";

const PermissionName = PermissionNames.ROLES;

export const getColumns = ({
  formatMessage,
  handleDeleteIntent,
  onEdit,
  onCancel,
  onSave,
  saveInProgress,
  editingKey,
  customerId,
  sport,
  organizationId,
}) => [
  {
    title: formatMessage({
      id: "name.local.full",
      defaultMessage: "Local Full Name",
    }),
    dataIndex: ["person", "nameFullLocal"],
    render: (value, row) => (
      <Space size="small">
        <Avatar src={row.person.image} size={25} loading="lazy" shape="square" alt="Team logo" />
        {value}
      </Space>
    ),
  },
  {
    title: formatMessage({
      id: "role",
      defaultMessage: "Role",
    }),
    width: 160,
    dataIndex: "role",
    editable: true,
    render: (value) => formatMessage({ id: `roles.${getRoleTranslationKey(value, sport)}` }),
  },
  {
    title: null,
    width: 200,
    align: "right",
    render: (value, row) => (
      <Space size="small">
        {editingKey === row.roleId ? (
          <>
            <Button
              type="primary"
              size="small"
              icon={<i className="fas fa-check" />}
              onClick={() => onSave(row)}
              loading={saveInProgress}
            />
            <Button size="small" icon={<i className="fas fa-cancel" />} onClick={onCancel} disabled={saveInProgress} />
          </>
        ) : (
          <>
            <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.UPDATE]}>
              <StyledButton size="small" type="text" onClick={() => onEdit(row)}>
                {formatMessage({
                  id: "manage",
                  defaultMessage: "Manage",
                })}
              </StyledButton>
            </PermissionCheck>
            <PermissionCheck
              permissionKeys={[PermissionNames.PERSON]}
              permissionOptions={[PermissionOperations.UPDATE]}
            >
              <StyledButton type="text" size="small">
                <Link
                  to={getEditPersonLink({
                    customerId,
                    sport,
                    organizationId,
                    personId: row.person.id,
                  })}
                >
                  <FormattedMessage id="details" defaultMessage="Details" />
                </Link>
              </StyledButton>
            </PermissionCheck>
            <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.DELETE]}>
              <StyledButton
                type="text"
                size="small"
                icon={<i className="fas fa-trash" />}
                onClick={() => handleDeleteIntent(row.roleId)}
              />
            </PermissionCheck>
          </>
        )}
      </Space>
    ),
  },
];
